import React from 'react'

import { useCurrentUserId } from 'lib/use-current-user-id'

import Create from './Buttons/Create'
import UserMenu from './Buttons/UserMenu'
import Wrapper from './Wrapper'

interface Props {
  children?: React.ReactNode | React.ReactNode[]
  creator?: {
    profileName: string
    logoURL: string
  }
  className?: string
}

const Header = ({ children, creator, className }: Props) => {
  const userId = useCurrentUserId()

  const actions = children || [
    <Create key={`top_create_${userId}`} />,
    <UserMenu key={`top_user_menu_${userId}`} />,
  ]

  return (
    <Wrapper creator={creator} className={className ? className : ''}>
      {actions}
    </Wrapper>
  )
}

export default Header
